(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 5194:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[[...index]]",
      function () {
        return __webpack_require__(3692);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 3692:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* reexport */ App; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./src/store/router.js
var store_router = __webpack_require__(5577);
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/TransitionGroup.js + 2 modules
var TransitionGroup = __webpack_require__(9747);
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/Transition.js + 1 modules
var Transition = __webpack_require__(8885);
// EXTERNAL MODULE: ./node_modules/gsap/index.js + 1 modules
var gsap = __webpack_require__(990);
// EXTERNAL MODULE: ./src/config.js
var config = __webpack_require__(9032);
;// CONCATENATED MODULE: ./src/components/Card.js


class Card extends (/* unused pure expression or super */ null && (Component)) {
    render() {
        const { title , description  } = this.props;
        return /*#__PURE__*/ _jsxs("div", {
            className: "card",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "title",
                    children: title
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "description",
                    children: description
                }),
                /*#__PURE__*/ _jsx("button", {
                    children: "More"
                })
            ]
        });
    }
}


// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var src_define_property = __webpack_require__(4924);
;// CONCATENATED MODULE: ./src/components/Container.js
//
// Container provides a wrapper which stretches the whole width of the window
// with a container inner which is centered and stretches the max width of the content
//


class Container extends react.Component {
    render() {
        const { children , wrapperClassName , className , wrapperStyle , style , wrapperId , id , before: Before , after: After , wrapperOnClick , onClick  } = this.props;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "container-wrapper ".concat(wrapperClassName || ""),
            style: wrapperStyle,
            id: wrapperId,
            onClick: wrapperOnClick,
            children: [
                Before && /*#__PURE__*/ (0,jsx_runtime.jsx)(Before, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container ".concat(className || ""),
                    style: style,
                    id: id,
                    onClick: onClick,
                    children: children
                }),
                After && /*#__PURE__*/ (0,jsx_runtime.jsx)(After, {})
            ]
        });
    }
}


// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./src/components/Background.js
//import React, {Component} from 'react';


const BackgroundComp = dynamic_default()(()=>Promise.all(/* import() | background-bundle */[__webpack_require__.e(737), __webpack_require__.e(304), __webpack_require__.e(670)]).then(__webpack_require__.bind(__webpack_require__, 3178)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(3178)
            ]
    },
    ssr: false
});
function Background(props) {
    if (!props.type) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "background",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BackgroundComp, {
            ...props
        })
    });
}

;// CONCATENATED MODULE: ./src/assets/index.js
function imgUrl(filename) {
    return "/assets/".concat(filename);
}
const assets_assets = {
    x: imgUrl("x.svg"),
    arrow_down: imgUrl("arrow_down.svg"),
    landing_logo: imgUrl("landing_logo.gif"),
    menu_logo: imgUrl("menu_logo.svg"),
    menu_bars: imgUrl("menu_bars.svg"),
    menu_arrow_down: imgUrl("menu_arrow_down.svg"),
    facebook: imgUrl("facebook.svg"),
    instagram: imgUrl("instagram.svg"),
    linkedin: imgUrl("linkedin.svg")
};
/* harmony default export */ var src_assets = (assets_assets);

// EXTERNAL MODULE: ./src/store/images.js
var store_images = __webpack_require__(562);
// EXTERNAL MODULE: ./node_modules/react-blurhash/es/index.js + 3 modules
var es = __webpack_require__(7956);
// EXTERNAL MODULE: ./node_modules/usehooks-ts/dist/esm/index.js + 36 modules
var esm = __webpack_require__(5678);
// EXTERNAL MODULE: ./node_modules/use-element-fit/dist/index.js
var dist = __webpack_require__(3538);
;// CONCATENATED MODULE: ./src/components/image.js






// Hook to help us combine img, blurhash and our imageStore
function useImg(param) {
    let { style , ...other } = param;
    var ref, ref1, ref2;
    const { height: heightProp  } = other;
    const imageStore = (0,store_images/* useImagesStore */.n_)();
    const [setSizeElementRef, { width , height  }] = (0,esm/* useElementSize */.h4)();
    const { handleImageOnLoad , css  } = (0,esm/* useImageOnLoad */.E3)();
    const imageData = imageStore === null || imageStore === void 0 ? void 0 : (ref = imageStore.images) === null || ref === void 0 ? void 0 : ref[other.src];
    // if height == 'auto' lets auto compute the height based on the image aspect ratio
    let autoHeight = null;
    if (imageData) {
        const aspectRatio = imageData.width / imageData.height;
        if (heightProp == "auto") {
            autoHeight = width / aspectRatio;
        }
    }
    const elFit = (0,dist.useElementFit)((imageData === null || imageData === void 0 ? void 0 : imageData.width) || 1, (imageData === null || imageData === void 0 ? void 0 : imageData.height) || 1, dist.ScaleMode.COVER); // half the width and the full height of parent element
    const setSizeRef = (ref)=>{
        elFit.ref.current = ref;
        setSizeElementRef(ref);
    };
    const setImageRef = (ref)=>{
        if (ref === null || ref === void 0 ? void 0 : ref.complete) {
            handleImageOnLoad();
        }
    };
    const blurhashVisible = width > 0 && height > 0 && (imageData === null || imageData === void 0 ? void 0 : (ref1 = imageData.blurhash) === null || ref1 === void 0 ? void 0 : ref1.hash);
    return {
        //width,
        //height,
        //css,
        containerProps: {
            ref: setSizeRef,
            style: {
                display: "inline-block",
                width: "100%",
                height: autoHeight || "100%",
                //background: 'yellow',
                position: "relative",
                overflow: "hidden"
            }
        },
        imgProps: {
            ref: setImageRef,
            onLoad: handleImageOnLoad,
            src: other.src,
            style: {
                //objectFit: 'cover',
                position: "absolute",
                width: elFit.width,
                height: elFit.height,
                top: elFit.y,
                left: elFit.x,
                ...css.fullSize
            }
        },
        blurhashVisible,
        blurhashProps: {
            width,
            height,
            hash: imageData === null || imageData === void 0 ? void 0 : (ref2 = imageData.blurhash) === null || ref2 === void 0 ? void 0 : ref2.hash,
            style: {
                width: elFit.width,
                height: elFit.height
            }
        },
        blurhashContainerProps: {
            style: {
                width: elFit.width,
                height: elFit.height,
                top: elFit.y,
                left: elFit.x,
                position: "absolute",
                ...css.thumbnail
            }
        }
    };
}
const BlurhashContainer = (param)=>{
    let { blurhashVisible , blurhashContainerProps , blurhashProps  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "_blurhash-container",
        ...blurhashContainerProps,
        children: blurhashVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Blurhash */.E, {
            ...blurhashProps
        })
    });
};
function ImageBlurhash(props) {
    const { style , ...other } = props;
    const im = useImg(props);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ...im.containerProps,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BlurhashContainer, {
                ...im
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                ...im.imgProps
            })
        ]
    });
}
function image_Image(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
        ...props
    });
}

// EXTERNAL MODULE: ./node_modules/react-helmet/es/Helmet.js
var Helmet = __webpack_require__(4593);
;// CONCATENATED MODULE: ./src/components/PageHeader.js









class PageHeader extends react.Component {
    componentDidMount() {
    // play all videos at half speed!
    /*const videoElement = document.getElementById('header-video');
        if (videoElement) {
            videoElement.playbackRate = 0.5;
            videoElement.addEventListener("canplaythrough", () => {
                console.log("Video loaded");
                //this.props.setVideoLoading(false);
            }, false);
        }*/ }
    render() {
        const { title , subTitle , titleComponent , tags , backgroundImage , onLeft , onRight , leftUrl , rightUrl , onClose , className , router  } = this.props;
        const showLeftArrow = onLeft || leftUrl && leftUrl.length > 0;
        const showRightArrow = onRight || rightUrl && rightUrl.length > 0;
        if (titleComponent) {
            return titleComponent(this.props);
        }
        const cleanTitle = title === null || title === void 0 ? void 0 : title.replace("<br/>", " ").trim();
        const fullTitle = !!cleanTitle ? "JP Media - ".concat(cleanTitle) : "JP Media";
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
            wrapperClassName: "page-header page_header_module ".concat(className !== null && className !== void 0 ? className : ""),
            before: this.renderBefore,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Helmet/* Helmet */.q, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                            children: fullTitle
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            name: "title",
                            property: "og:title",
                            content: fullTitle
                        })
                    ]
                }),
                onClose && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    className: "btn-x",
                    onClick: onClose,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(image_Image, {
                        src: src_assets.x
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: [
                        "title-arrows-container",
                        router.asPath == "/" ? "home" : ""
                    ].join(" "),
                    children: [
                        (showLeftArrow || showRightArrow) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "arrows",
                            children: [
                                showLeftArrow && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    className: "btn btn-left",
                                    onClick: this.onLeft,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(image_Image, {
                                        src: src_assets.arrow_down
                                    })
                                }),
                                showRightArrow && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    className: "btn btn-right",
                                    onClick: this.onRight,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(image_Image, {
                                        src: src_assets.arrow_down
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "title",
                            dangerouslySetInnerHTML: {
                                __html: title
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "subtitle",
                            dangerouslySetInnerHTML: {
                                __html: subTitle
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "tags",
                            dangerouslySetInnerHTML: {
                                __html: tags
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: "btn btn-down arrow-down",
                            onClick: this.onDown,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(image_Image, {
                                src: src_assets.arrow_down
                            })
                        })
                    ]
                })
            ]
        });
    }
    constructor(props){
        super(props);
        (0,src_define_property/* default */.Z)(this, "onLeft", ()=>{
            const { onLeft , router , leftUrl  } = this.props;
            if (onLeft) {
                onLeft();
            } else {
                router.push(leftUrl, {
                    transition: "left"
                });
            }
        });
        (0,src_define_property/* default */.Z)(this, "onRight", ()=>{
            const { onRight , router , rightUrl  } = this.props;
            if (onRight) {
                onRight();
            } else {
                router.push(rightUrl, {
                    transition: "right"
                });
            }
        });
        (0,src_define_property/* default */.Z)(this, "usesVideo", ()=>{
            const { backgroundVideo  } = this.props;
            if (!backgroundVideo) {
                return false;
            }
            return true;
        });
        (0,src_define_property/* default */.Z)(this, "onDown", ()=>{
            const page = document.getElementsByClassName("page")[0];
            const e = document.getElementsByClassName("page-header")[0];
            page.scroll({
                left: 0,
                top: e.scrollHeight,
                behavior: "smooth"
            });
        });
        (0,src_define_property/* default */.Z)(this, "renderBefore", ()=>{
            const { renderBefore , background , backgroundImage , backgroundProperties , backgroundVideo  } = this.props;
            if (renderBefore) {
                return renderBefore(this.props);
            }
            if (backgroundImage || this.usesVideo()) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "background",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageBlurhash, {
                            src: backgroundImage
                        }),
                        this.usesVideo() && /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                            autoPlay: true,
                            loop: true,
                            muted: true,
                            id: "header-video",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                src: backgroundVideo,
                                type: "video/mp4"
                            })
                        })
                    ]
                });
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Background, {
                type: background,
                properties: backgroundProperties
            });
        });
        if (this.usesVideo()) {
            console.log("Video loading....");
        //props.setVideoLoading(true);
        }
    }
}
/* harmony default export */ var components_PageHeader = ((0,store_router/* withRouter */.EN)(PageHeader));

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/components/Social.js




const Social = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "social",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "inner-container",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: "https://www.facebook.com/jpmediaadelaide",
                    target: "_blank",
                    className: "facebook",
                    rel: "noreferrer",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(image_Image, {
                        src: src_assets.facebook,
                        alt: ""
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: "https://www.instagram.com/jpmedia_adelaide/",
                    target: "_blank",
                    className: "instagram",
                    rel: "noreferrer",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(image_Image, {
                        src: src_assets.instagram,
                        alt: ""
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: "https://au.linkedin.com/company/jp-media-australia-",
                    target: "_blank",
                    className: "linkedin",
                    rel: "noreferrer",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(image_Image, {
                        src: src_assets.linkedin,
                        alt: ""
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var components_Social = (Social);

;// CONCATENATED MODULE: ./src/components/Footer.js




class Footer extends react.Component {
    render() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "footer",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "copyright",
                    children: "All content Copyright \xa9 JP Media 2021"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Social, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "privacy",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "privacy",
                        children: "Privacy"
                    })
                })
            ]
        });
    }
}
/* harmony default export */ var components_Footer = (Footer);

;// CONCATENATED MODULE: ./src/components/PageTpl.js
//
// Page Template
//
// Provides a base template for rendering all the pages
//



class PageTpl extends react.Component {
    render() {
        const { className , children  } = this.props;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "page ".concat(className),
            children: [
                children,
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Footer, {})
            ]
        });
    }
}
/* harmony default export */ var components_PageTpl = (PageTpl);

;// CONCATENATED MODULE: ./src/components/WhatWeDo.js







class WhatWeDo extends react.Component {
    render() {
        const { title , className , pages  } = this.props;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
            wrapperClassName: "what-we-do ".concat(className),
            children: [
                title && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "title",
                    children: title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "card-grid",
                    children: pages === null || pages === void 0 ? void 0 : pages.map((item, index)=>{
                        return this.renderItem(item, index);
                    })
                })
            ]
        });
    }
    constructor(...args){
        super(...args);
        (0,src_define_property/* default */.Z)(this, "renderItem", (props, index)=>{
            const { className  } = this.props;
            const { title , shortExcerpt , excerpt , buttonLabel , url , id  } = props;
            const full = className && className.includes("full");
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                href: url,
                className: "card",
                id: id,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "header",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "title",
                                children: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "btn-right",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(image_Image, {
                                    src: src_assets.arrow_down,
                                    alt: ""
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "description",
                        children: full ? excerpt : shortExcerpt
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "btn btn-opacity",
                        children: buttonLabel
                    })
                ]
            }, index);
        });
    }
}


// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/CSSTransition.js + 3 modules
var esm_CSSTransition = __webpack_require__(6743);
// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(5518);
;// CONCATENATED MODULE: ./src/utils/use-is-mobile.js
// Hook to determine when we switch to mobile view


function useIsMobile() {
    const { width , height  } = (0,esm/* useWindowSize */.iP)();
    const isNarrow = width <= 647;
    return lib/* isMobile */.tq || isNarrow;
}

;// CONCATENATED MODULE: ./src/components/HoverCard.js






class HoverCardComp extends react.Component {
    render() {
        const { title , description , className , buttonText , clickable , image , underlayImage , isMobile  } = this.props;
        const { hover  } = this.state;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "hover-card ".concat(className !== null && className !== void 0 ? className : "", " ").concat(hover ? "hover" : "", " ").concat(clickable ? "clickable" : "not-clickable"),
            onMouseEnter: ()=>this.setState({
                    hover: true
                }),
            onMouseLeave: ()=>this.setState({
                    hover: false
                }),
            onClick: this.onClick,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_CSSTransition/* default */.Z, {
                    in: hover,
                    timeout: 300,
                    classNames: "fade",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "overlay",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "title-img",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageBlurhash, {
                                    src: image,
                                    alt: "",
                                    height: isMobile ? "auto" : null
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "title",
                                children: title
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "underlay ".concat(underlayImage ? "with-underlay-img" : ""),
                    children: [
                        underlayImage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "underlay-img",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageBlurhash, {
                                src: underlayImage,
                                alt: ""
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "title",
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "description",
                            dangerouslySetInnerHTML: {
                                __html: description
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: "button",
                            children: buttonText
                        })
                    ]
                })
            ]
        });
    }
    constructor(...args){
        super(...args);
        (0,src_define_property/* default */.Z)(this, "state", {
            hover: false
        });
        (0,src_define_property/* default */.Z)(this, "onClick", ()=>{
            const { onClick , history , location , clickable  } = this.props;
            if (!clickable) {
                return;
            }
            const url = this.props.url || this.props.pageUrl;
            if (onClick) {
                onClick(this.props);
                return;
            }
            if (url) {
                history.push({
                    pathname: url,
                    state: {
                        prevPath: location.pathname
                    }
                });
            }
        });
    }
}
(0,src_define_property/* default */.Z)(HoverCardComp, "defaultProps", {
    buttonText: "Learn more",
    clickable: true
});
function HoverCard(props) {
    const isMobile = useIsMobile();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HoverCardComp, {
        isMobile: isMobile,
        ...props
    });
}

;// CONCATENATED MODULE: ./src/components/CardGrid.js




class GridCard extends react.Component {
    render() {
        const { className , content , component , componentProps  } = this.props;
        const CardComp = component || HoverCard;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
            className: "".concat(className || "", " card-grid"),
            children: content === null || content === void 0 ? void 0 : content.map((item, index)=>{
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(CardComp, {
                    ...componentProps,
                    ...item
                }, index);
            })
        });
    }
}


;// CONCATENATED MODULE: ./src/components/NextStory.js





class NextStory extends react.Component {
    render() {
        const { title , backgroundImage , onClick  } = this.props;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
            wrapperClassName: "next-story",
            //wrapperStyle={{backgroundImage: `url(${backgroundImage})`}} 
            wrapperOnClick: onClick,
            before: ()=>{
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    /*style={{position: 'absolute', top: 0, bottom: 0, left: 0, right: 0}}*/ className: "before",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageBlurhash, {
                            src: backgroundImage
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "before-image-overlay"
                        })
                    ]
                });
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "title",
                    children: "Next Story"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "subtitle",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(image_Image, {
                            src: src_assets.arrow_down
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    children: "Read now"
                })
            ]
        });
    }
}


;// CONCATENATED MODULE: ./src/components/index.js










;// CONCATENATED MODULE: ./src/pages/PageNotFound.js





function PageNotFound() {
    const router = (0,store_router/* useRouter */.tv)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_PageTpl, {
        className: "contact-page",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_PageHeader, {
                title: "Not Found",
                subTitle: "HTTP 404"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
                className: "intro",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: "The page you are looking for does not exist."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: "btn-black",
                        onClick: ()=>router.push("/"),
                        style: {
                            marginTop: "10px"
                        },
                        children: "Home"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            height: "80vh"
                        }
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/services/analytics.js
var analytics = __webpack_require__(127);
;// CONCATENATED MODULE: ./src/components/TeamMemberCard.js








class TeamMemberCard extends react.Component {
    render() {
        const { className , title , role , quote , bio , phone , email , linkedin , onClick , buttonText  } = this.props;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: className,
            onClick: onClick,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "title",
                    children: title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "role",
                    children: role
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    dangerouslySetInnerHTML: {
                        __html: quote
                    },
                    className: "quote"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    dangerouslySetInnerHTML: {
                        __html: bio
                    },
                    className: "bio"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "contact-container",
                    children: [
                        phone && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "tel:".concat(phone),
                            onClick: ()=>(0,analytics/* gaEvent */.jW)({
                                    category: "contact",
                                    action: "phone_clicked",
                                    label: phone
                                }),
                            children: phone
                        }),
                        email && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "mailto:".concat(email),
                            onClick: ()=>(0,analytics/* gaEvent */.jW)({
                                    category: "contact",
                                    action: "email_clicked",
                                    label: email
                                }),
                            children: email
                        }),
                        linkedin && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: linkedin,
                            target: "_blank",
                            className: "linkedin",
                            rel: "noreferrer",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(image_Image, {
                                src: src_assets.linkedin,
                                alt: ""
                            })
                        })
                    ]
                }),
                onClick && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    className: "button",
                    onClick: onClick,
                    children: buttonText
                })
            ]
        });
    }
}
class TeamMemberHoverCardInner extends react.Component {
    render() {
        const { title , image , className , isMobile , ...otherProps } = this.props;
        const { hover  } = this.state;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "hover-card ".concat(className !== null && className !== void 0 ? className : "", " ").concat(hover ? "hover" : ""),
            onMouseEnter: ()=>this.setState({
                    hover: true
                }),
            onMouseLeave: ()=>this.setState({
                    hover: false
                }),
            onClick: this.onClick,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_CSSTransition/* default */.Z, {
                    in: hover,
                    timeout: 300,
                    classNames: "fade",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "overlay",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "title-img",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageBlurhash, {
                                    src: image,
                                    alt: "",
                                    height: isMobile ? "auto" : null
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "title",
                                children: title
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TeamMemberCard, {
                    title: title,
                    ...otherProps,
                    className: "underlay"
                })
            ]
        });
    }
    constructor(...args){
        super(...args);
        (0,src_define_property/* default */.Z)(this, "state", {
            hover: false
        });
        (0,src_define_property/* default */.Z)(this, "onClick", ()=>{
            const { onClick , url , history  } = this.props;
            if (onClick) {
                onClick(this.props);
                return;
            }
            if (url) {
                history.push(url);
            }
        });
    }
}
(0,src_define_property/* default */.Z)(TeamMemberHoverCardInner, "defaultProps", {
    buttonText: "Learn more"
});
function TeamMemberHoverCard(props) {
    const isMobile = useIsMobile();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TeamMemberHoverCardInner, {
        isMobile: isMobile,
        ...props
    });
}

;// CONCATENATED MODULE: ./src/components/Modal.js



class Modal extends react.Component {
    componentDidMount() {
        if (this.props.visible) {
            setTimeout(()=>{
                this.setState({
                    animateOverlay: true
                }, ()=>{
                    setTimeout(()=>{
                        this.setState({
                            animateBody: true
                        });
                    }, 1);
                });
            }, 1);
        } else {
            setTimeout(()=>{
                this.setState({
                    animateOverlay: false
                }, ()=>{
                    setTimeout(()=>{
                        this.setState({
                            animateBody: false
                        });
                    }, 1);
                });
            }, 1);
        }
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.visible) {
            setTimeout(()=>{
                this.setState({
                    animateOverlay: true
                }, ()=>{
                    setTimeout(()=>{
                        this.setState({
                            animateBody: true
                        });
                    }, 1);
                });
            }, 1);
        } else {
            setTimeout(()=>{
                this.setState({
                    animateOverlay: false
                }, ()=>{
                    setTimeout(()=>{
                        this.setState({
                            animateBody: false
                        });
                    }, 1);
                });
            }, 1);
        }
    }
    render() {
        let { animateOverlay , animateBody  } = this.state;
        let { visible , className  } = this.props;
        let type = undefined;
        if (this.props.type !== undefined) {
            type = this.props.type;
        }
        if (visible) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "react-modal ".concat(className !== null && className !== void 0 ? className : ""),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_CSSTransition/* default */.Z, {
                            in: animateOverlay,
                            timeout: 500,
                            classNames: "animate-modal-overlay",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "react-modal-overlay",
                                onClick: ()=>// this.setState({ animate: false }, () => {
                                    //     setTimeout(() => {
                                    //         this.props.closemodal();
                                    //     }, 500);
                                    // })
                                    this.setState({
                                        animateBody: false
                                    }, ()=>{
                                        this.setState({
                                            animateOverlay: false
                                        }, ()=>{
                                            setTimeout(()=>{
                                                this.props.closemodal();
                                            }, 501);
                                        });
                                    })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_CSSTransition/* default */.Z, {
                            in: animateBody,
                            timeout: 450,
                            classNames: type !== undefined ? type : "flipInX",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "react-modal-body",
                                children: this.props.children
                            })
                        })
                    ]
                })
            });
        } else {
            return null;
        }
    }
    constructor(){
        super();
        this.state = {
            animateOverlay: false,
            animateBody: false
        };
    }
}


;// CONCATENATED MODULE: ./src/page_builder/TeamMembersGridModule.js








class TeamMembersGridModule extends react.Component {
    render() {
        const { members , name  } = this.props;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: name,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(GridCard, {
                    content: members,
                    componentProps: {
                        className: "team-hover-card",
                        buttonText: "Read More",
                        onClick: this.onClick
                    },
                    component: TeamMemberHoverCard
                }),
                this.renderModal()
            ]
        });
    }
    constructor(props){
        super(props);
        (0,src_define_property/* default */.Z)(this, "onClick", (props)=>{
            this.setState({
                currentTeamMember: props
            });
        });
        (0,src_define_property/* default */.Z)(this, "onLeft", ()=>{
            const { currentTeamMember  } = this.state;
            const { members  } = this.props;
            const idx = members.findIndex((t)=>t.id === currentTeamMember.id);
            const nextTeamMember = members[idx === 0 ? members.length - 1 : idx - 1];
            this.setState({
                currentTeamMember: nextTeamMember
            });
        });
        (0,src_define_property/* default */.Z)(this, "onRight", ()=>{
            const { currentTeamMember  } = this.state;
            const { members  } = this.props;
            const idx = members.findIndex((t)=>t.id === currentTeamMember.id);
            const nextTeamMember = members[idx === members.length - 1 ? 0 : idx + 1];
            this.setState({
                currentTeamMember: nextTeamMember
            });
        });
        (0,src_define_property/* default */.Z)(this, "renderModal", ()=>{
            const { currentTeamMember  } = this.state;
            const { image  } = currentTeamMember !== null && currentTeamMember !== void 0 ? currentTeamMember : {};
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal, {
                visible: currentTeamMember,
                closemodal: ()=>this.setState({
                        currentTeamMember: null
                    }),
                type: "fadeInUp",
                className: "team-page",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "btn-left-container",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: "btn btn-left",
                            onClick: this.onLeft,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(image_Image, {
                                src: src_assets.arrow_down
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "modal-body-container",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "btn-x-container",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    className: "btn-x",
                                    onClick: ()=>this.setState({
                                            currentTeamMember: null
                                        }),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(image_Image, {
                                        src: src_assets.x
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "title-img",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageBlurhash, {
                                    src: image
                                }, image)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TeamMemberCard, {
                                ...currentTeamMember,
                                onClick: null,
                                className: "container"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "btn-right-container",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: "btn btn-right",
                            onClick: this.onRight,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(image_Image, {
                                src: src_assets.arrow_down
                            })
                        })
                    })
                ]
            });
        });
        this.state = {
            currentTeamMember: null
        };
    }
}


;// CONCATENATED MODULE: ./src/page_builder/OneColumnModule.js




class OneColumnModule extends react.Component {
    render() {
        const { column1Content , buttonLabel , buttonLink , backgroundColour , name , className  } = this.props;
        var ref;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
            wrapperClassName: "".concat(name, " ").concat((ref = className === null || className === void 0 ? void 0 : className.join(" ")) !== null && ref !== void 0 ? ref : ""),
            wrapperStyle: {
                backgroundColor: backgroundColour
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    dangerouslySetInnerHTML: {
                        __html: column1Content
                    }
                }),
                buttonLink && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: buttonLink,
                    className: "btn btn-black",
                    children: buttonLabel
                })
            ]
        });
    }
}


;// CONCATENATED MODULE: ./src/page_builder/TwoColumnModule.js



class TwoColumnModule extends react.Component {
    render() {
        const { column1Content , column2Content , backgroundColour , name , className  } = this.props;
        var ref;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
            wrapperClassName: "".concat(name, " ").concat((ref = className === null || className === void 0 ? void 0 : className.join(" ")) !== null && ref !== void 0 ? ref : ""),
            wrapperStyle: {
                backgroundColor: backgroundColour
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    dangerouslySetInnerHTML: {
                        __html: column1Content
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    dangerouslySetInnerHTML: {
                        __html: column2Content
                    }
                })
            ]
        });
    }
}


;// CONCATENATED MODULE: ./src/page_builder/ServiceGridModule.js



class ServiceGridModule extends react.Component {
    render() {
        const { services , name , title  } = this.props;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
                    className: "".concat(name, " title"),
                    children: title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(GridCard, {
                    title: title,
                    className: name,
                    content: services,
                    componentProps: {
                        clickable: false
                    }
                })
            ]
        });
    }
}


// EXTERNAL MODULE: ./src/store/caseStudies.js
var caseStudies = __webpack_require__(8513);
;// CONCATENATED MODULE: ./src/services/case-study.js
const getCaseStudyImages = (caseStudy)=>{
    const images = [];
    const pageHeaderModule = caseStudy.pageBuilder.find((m)=>{
        return m.acfFcLayout === "page_header_module";
    });
    if (pageHeaderModule) {
        images.push(pageHeaderModule.backgroundImage);
    }
    const imageModule = caseStudy.pageBuilder.find((m)=>{
        return m.acfFcLayout === "image_module";
    });
    if (imageModule) {
        images.push(imageModule.image);
    }
    const imageAndContentModule = caseStudy.pageBuilder.find((m)=>{
        return m.acfFcLayout === "image_and_content_module";
    });
    if (imageAndContentModule) {
        images.push(imageAndContentModule.image.url);
    }
    return images;
};

;// CONCATENATED MODULE: ./src/page_builder/CaseStudiesGridModule.js






function CaseStudiesGridModule(props) {
    const router = (0,store_router/* useRouter */.tv)();
    const caseStudiesStore = (0,caseStudies/* useCaseStudiesStore */.rY)();
    const onClick = (p)=>{
        router.push("/case-study/".concat(p.id), {
            prevPath: router.asPath
        });
    };
    const { name , title  } = props;
    const content = (0,react.useMemo)(()=>{
        var ref;
        return ((ref = caseStudiesStore.caseStudies) === null || ref === void 0 ? void 0 : ref.map((cs)=>{
            const newCaseStudy = {
                ...cs
            };
            const images = getCaseStudyImages(cs);
            newCaseStudy.image = images[0];
            newCaseStudy.underlayImage = images[1];
            return newCaseStudy;
        })) || [];
    }, [
        caseStudiesStore.caseStudies.length
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
                className: "".concat(name, " title"),
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GridCard, {
                className: name,
                content: content,
                componentProps: {
                    onClick
                }
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/page_builder/CalloutModule.js




class CalloutModule extends react.Component {
    render() {
        const { title , subTitle , buttonLabel , buttonLink , name  } = this.props;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: buttonLink,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
                wrapperClassName: name,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "title",
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "subtitle",
                        children: subTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        to: buttonLink,
                        className: "btn btn-opacity",
                        children: buttonLabel
                    })
                ]
            })
        });
    }
}


;// CONCATENATED MODULE: ./src/page_builder/ServicesCategoryPagesModule.js



class ServicesCategoryPagesModule extends react.Component {
    render() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(WhatWeDo, {
            ...this.props
        });
    }
}


;// CONCATENATED MODULE: ./src/page_builder/PageHeaderModule.js



class PageHeaderModule extends react.Component {
    render() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_PageHeader, {
            ...this.props
        });
    }
}


;// CONCATENATED MODULE: ./src/page_builder/ImageModule.js



class ImageModule extends react.Component {
    render() {
        const { image , name  } = this.props;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
            wrapperClassName: name,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageBlurhash, {
                src: image,
                alt: "",
                height: "auto"
            })
        });
    }
}


;// CONCATENATED MODULE: ./src/page_builder/SingleContentModule.js




class SingleContentModule extends react.Component {
    render() {
        const { Content , buttonLabel , buttonLink , backgroundColour , name , className  } = this.props;
        var ref;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
            wrapperClassName: "".concat(name, " ").concat((ref = className === null || className === void 0 ? void 0 : className.join(" ")) !== null && ref !== void 0 ? ref : ""),
            wrapperStyle: {
                backgroundColor: backgroundColour
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    dangerouslySetInnerHTML: {
                        __html: Content
                    }
                }),
                buttonLink && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: buttonLink,
                    className: "btn btn-black",
                    children: buttonLabel
                })
            ]
        });
    }
}


;// CONCATENATED MODULE: ./src/page_builder/FullWidthImageModule.js



class FullWidthImageModule extends react.Component {
    render() {
        const { image , name  } = this.props;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: name,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageBlurhash, {
                src: image,
                alt: ""
            })
        });
    }
}


;// CONCATENATED MODULE: ./src/page_builder/ImageAndContentModule.js




class ImageAndContentModule extends react.Component {
    render() {
        const { columnContent , image , imageAlignment , Video: video , videoAlignment , buttonLabel , buttonLink , name  } = this.props;
        if (video) {
            console.log("vid");
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
            wrapperClassName: "".concat(name, " ").concat(imageAlignment, " ").concat(videoAlignment),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "content-col",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            dangerouslySetInnerHTML: {
                                __html: columnContent
                            }
                        }),
                        buttonLink && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: buttonLink,
                            className: "btn btn-black",
                            children: buttonLabel
                        })
                    ]
                }),
                image && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "image-col",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(image_Image, {
                        src: image === null || image === void 0 ? void 0 : image.url,
                        alt: ""
                    })
                }),
                video && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "video-col",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                        controls: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                            src: video
                        })
                    })
                })
            ]
        });
    }
}


// EXTERNAL MODULE: ./src/utils/fetch.js
var utils_fetch = __webpack_require__(5349);
;// CONCATENATED MODULE: ./src/services/contact.js


const postContact = (args)=>{
    const params = (0,utils_fetch/* serializeURI */.OK)(args);
    return fetch("".concat(config/* default.API.BASEPATH */.Z.API.BASEPATH, "/add-contact-entry?").concat(params), {
        method: "POST"
    });
};
const postCareerContact = (args)=>{
    const params = (0,utils_fetch/* serializeURI */.OK)(args);
    return fetch("".concat(config/* default.API.BASEPATH */.Z.API.BASEPATH, "/add-career-contact-entry?").concat(params), {
        method: "POST"
    });
};

;// CONCATENATED MODULE: ./src/page_builder/CareerContactFormModule.js





const fields = [
    "name",
    "phone_number",
    "email",
    "message"
];
class CareerContactFormModuleComp extends react.Component {
    render() {
        const { show  } = this.props;
        const { busy , submittedOk  } = this.state;
        if (!show) {
            return null;
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
            className: "form",
            children: [
                !submittedOk && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "row-1",
                        style: {
                            minWidth: "50vw"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "col-2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    placeholder: "Your Name",
                                    id: "name",
                                    required: true
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    placeholder: "Phone",
                                    id: "phone_number",
                                    pattern: "[0-9]{8,12}",
                                    type: "tel",
                                    required: true
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    placeholder: "Email",
                                    id: "email",
                                    type: "email",
                                    pattern: "[^@\\s]+@[^@\\s]+\\.[^@\\s]+",
                                    required: true
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
                                    placeholder: "Your message...",
                                    id: "message",
                                    required: true
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    className: "btn-black submit",
                                    onClick: this.onSubmit,
                                    disabled: busy,
                                    children: "Send"
                                })
                            ]
                        })
                    })
                }),
                submittedOk && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "message",
                    children: "Your enquiry has been submitted"
                })
            ]
        });
    }
    constructor(...args){
        super(...args);
        (0,src_define_property/* default */.Z)(this, "state", {
            busy: false,
            submittedOk: false
        });
        (0,src_define_property/* default */.Z)(this, "onSubmit", (e)=>{
            const obj = {};
            let isValid = true;
            for (const f of fields){
                const domInput = document.getElementById(f);
                const valid = domInput.checkValidity();
                domInput.classList.remove("invalid");
                const value = domInput.value;
                if (!valid) {
                    isValid = false;
                    domInput.classList.add("invalid");
                }
                obj[f] = value;
            }
            if (!isValid) {
                return;
            }
            this.setState({
                busy: true
            });
            postCareerContact(obj).then((response)=>{
                if (response.status == 200) {
                    this.setState({
                        busy: false,
                        submittedOk: true
                    });
                } else {
                    alert("An error occured submitting your enquiry");
                    this.setState({
                        busy: false
                    });
                }
            }).catch((error)=>{
                alert("An error occured submitting your enquiry");
                this.setState({
                    busy: false
                });
            });
        });
    }
}
/* harmony default export */ var CareerContactFormModule = (CareerContactFormModuleComp);

;// CONCATENATED MODULE: ./src/page_builder/PageBuilder.js
















const moduleDefinitions = [
    {
        name: "Excerpt_Module",
        component: ()=>null
    },
    {
        name: "image_module",
        component: ImageModule
    },
    {
        name: "page_header_module",
        component: PageHeaderModule
    },
    {
        name: "team_members_grid_module",
        component: TeamMembersGridModule
    },
    {
        name: "one_column_module",
        component: OneColumnModule
    },
    {
        name: "two_column_module",
        component: TwoColumnModule
    },
    {
        name: "service_grid_module",
        component: ServiceGridModule
    },
    {
        name: "case_studies_grid_module",
        component: CaseStudiesGridModule
    },
    {
        name: "callout_module",
        component: CalloutModule
    },
    {
        name: "service_category_pages_module",
        component: ServicesCategoryPagesModule
    },
    {
        name: "single_content_module",
        component: SingleContentModule
    },
    {
        name: "fullwidth_image_module",
        component: FullWidthImageModule
    },
    {
        name: "image_and_content_module",
        component: ImageAndContentModule
    },
    {
        name: "video_and_content_module",
        component: ImageAndContentModule
    },
    {
        name: "career_contact_form",
        component: CareerContactFormModule
    }
];
const renderModule = (param)=>{
    let { definition , pmodule , index  } = param;
    const Component = definition.component;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, {
        ...definition,
        ...pmodule
    }, index);
};
class PageBuilder extends react.Component {
    render() {
        const { page , renderModule  } = this.props;
        if (!page) {
            return null;
        }
        const elements = [];
        let index = 0;
        for (const pmodule of page){
            const definition = moduleDefinitions.find((e)=>e.name === pmodule.acfFcLayout);
            if (!definition) {
                console.error("PageBuilder unknown acf_fc_layout: ", pmodule.acfFcLayout);
                continue;
            }
            elements.push(renderModule({
                definition,
                pmodule,
                index
            }));
            ++index;
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
            children: elements
        });
    }
}
(0,src_define_property/* default */.Z)(PageBuilder, "defaultProps", {
    renderModule
});
//
// Component that takes an array and assembles a bunch of components
//


;// CONCATENATED MODULE: ./src/pages/PageBuilderPage.js




class PageBuilderPage extends react.Component {
    render() {
        const { page  } = this.props;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_PageTpl, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PageBuilder, {
                page: page === null || page === void 0 ? void 0 : page.pageBuilder
            })
        });
    }
}
//
// The whole page that is build using a PageBuilder
//


// EXTERNAL MODULE: ./src/store/pages.js
var pages = __webpack_require__(9409);
// EXTERNAL MODULE: ./node_modules/google-map-react/dist/index.modern.js + 1 modules
var index_modern = __webpack_require__(6725);
;// CONCATENATED MODULE: ./src/pages/Contact.js









const map = {
    center: {
        lat: -34.9314241,
        lng: 138.5961823
    },
    zoom: 16,
    label: "JP Media, Level 2 36 Field St, Adelaide SA 5000"
};
const Contact_fields = [
    "name",
    "company",
    "enquiry",
    "email",
    "message"
];
class ContactComp extends react.Component {
    render() {
        var ref;
        const { busy , submittedOk  } = this.state;
        let pageBuilder = (ref = this.props.page) === null || ref === void 0 ? void 0 : ref.pageBuilder;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_PageTpl, {
            className: "contact-page",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_PageHeader, {
                    title: "Contact"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
                    className: "form",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-1",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PageBuilder, {
                                page: pageBuilder
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "col-2",
                            children: [
                                !submittedOk && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            placeholder: "Your Name",
                                            id: "name",
                                            required: true
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            placeholder: "Company",
                                            id: "company"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            placeholder: "Enquiry Type",
                                            id: "enquiry",
                                            required: true
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            placeholder: "Email",
                                            id: "email",
                                            type: "email",
                                            pattern: "[^@\\s]+@[^@\\s]+\\.[^@\\s]+",
                                            required: true
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
                                            placeholder: "Your message...",
                                            id: "message",
                                            rows: "8",
                                            required: true
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            className: "btn-black submit",
                                            onClick: this.onSubmit,
                                            disabled: busy,
                                            children: "Send"
                                        })
                                    ]
                                }),
                                submittedOk && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "message",
                                    children: "Your enquiry has been submitted"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
                    wrapperClassName: "map",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_modern/* default */.ZP, {
                        bootstrapURLKeys: {
                            key: config/* default.GOOGLE_MAPS_API_KEY */.Z.GOOGLE_MAPS_API_KEY
                        },
                        defaultCenter: map.center,
                        defaultZoom: map.zoom,
                        yesIWantToUseGoogleMapApiInternals: true,
                        onGoogleApiLoaded: (param)=>{
                            let { map , maps  } = param;
                            return this.renderMarkers(map, maps);
                        }
                    })
                })
            ]
        });
    }
    constructor(...args){
        super(...args);
        (0,src_define_property/* default */.Z)(this, "state", {
            busy: false,
            submittedOk: false
        });
        (0,src_define_property/* default */.Z)(this, "onSubmit", (e)=>{
            const obj = {};
            let isValid = true;
            for (const f of Contact_fields){
                const domInput = document.getElementById(f);
                const valid = domInput.checkValidity();
                domInput.classList.remove("invalid");
                const value = domInput.value;
                if (!valid) {
                    isValid = false;
                    domInput.classList.add("invalid");
                }
                obj[f] = value;
            }
            if (!isValid) {
                return;
            }
            this.setState({
                busy: true
            });
            postContact(obj).then((response)=>{
                if (response.status == 200) {
                    (0,analytics/* gaEvent */.jW)({
                        category: "contact",
                        action: "contact_form_submitted",
                        label: obj.email
                    });
                    this.setState({
                        busy: false,
                        submittedOk: true
                    });
                } else {
                    alert("An error occured submitting your enquiry");
                    this.setState({
                        busy: false
                    });
                }
            }).catch((error)=>{
                alert("An error occured submitting your enquiry");
                this.setState({
                    busy: false
                });
            });
        });
        (0,src_define_property/* default */.Z)(this, "renderMarkers", (gmap, gmaps)=>{
            let marker = new gmaps.Marker({
                position: gmap.center,
                map: gmap,
                animation: gmaps.Animation.DROP,
                title: map.label
            });
            return marker;
        });
    }
}
function ContactComp2(param) {
    let { page , ...other } = param;
    let pageBuilder = page === null || page === void 0 ? void 0 : page.pageBuilder;
    if (pageBuilder) {
        if (true) {
            window.gaEvent = analytics/* gaEvent */.jW;
        }
        pageBuilder = pageBuilder.map((comp)=>{
            if (comp.acfFcLayout == "single_content_module") {
                let newContent = comp.Content.replace('href="mailto:', "onClick=\"window.gaEvent({ category: 'contact', action: 'email_clicked' })\" href=\"mailto:");
                newContent = newContent.replace('href="tel:', "onClick=\"window.gaEvent({ category: 'contact', action: 'phone_clicked' })\" href=\"mailto:");
                return {
                    ...comp,
                    Content: newContent
                };
            }
            return comp;
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactComp, {
        page: {
            pageBuilder
        },
        ...other
    });
}
/* harmony default export */ var Contact = (ContactComp2);

// EXTERNAL MODULE: ./src/store/news.js
var news = __webpack_require__(4314);
;// CONCATENATED MODULE: ./src/pages/NewsFeed.js







class NewsFeedComp extends react.Component {
    render() {
        const { news  } = this.props;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_PageTpl, {
            className: "news-feed-page",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_PageHeader, {
                    title: "News",
                    titleComponent: this.renderHeader
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
                    wrapperClassName: "feed-container-wrapper",
                    children: news && news.map(this.renderItem)
                })
            ]
        });
    }
    constructor(...args){
        super(...args);
        (0,src_define_property/* default */.Z)(this, "onClick", (n, index)=>{
            const { router  } = this.props;
            const url = "/news/".concat(n.id);
            router.push(url, {
                prevPath: location.pathname
            });
        });
        (0,src_define_property/* default */.Z)(this, "renderHeader", (props)=>{
            const { title  } = props;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
                wrapperClassName: "page-header",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "title",
                    dangerouslySetInnerHTML: {
                        __html: title
                    }
                })
            });
        });
        (0,src_define_property/* default */.Z)(this, "renderItem", (n, index)=>{
            const { isMobile  } = this.props;
            // TODO: TEST EXCERPT CHANGES
            const { title , tags , pageBuilder , excerpt , page_author  } = n;
            const headerModule = pageBuilder.find((m)=>m.acfFcLayout === "page_header_module");
            //const excerptModule = pageBuilder.find(m => m.acfFcLayout === 'Excerpt_Module');
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "news-card",
                onClick: ()=>{
                    this.onClick(n, index);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageBlurhash, {
                        className: "image",
                        src: headerModule.backgroundImage,
                        alt: "",
                        id: "image-".concat(index),
                        height: isMobile ? "auto" : null
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "title",
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tags",
                        children: tags
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "excerpt",
                        children: excerpt /*excerptModule.excerpt*/ 
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: "btn-black",
                        children: "Learn more"
                    })
                ]
            }, index);
        });
    }
}
function NewsFeed() {
    const newsStore = (0,news/* useNewsStore */.m)();
    const router = (0,store_router/* useRouter */.tv)();
    const isMobile = useIsMobile;
    //console.log(newsStore.news);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsFeedComp, {
        news: newsStore.news,
        router: router,
        isMobile: isMobile
    });
}

;// CONCATENATED MODULE: ./src/pages/ArticlePage.js










class ArticlePage extends react.Component {
    render() {
        const caseStudy = this.getCurrentItem();
        if (!caseStudy) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(PageNotFound, {});
        }
        const rightItem = this.getNextItem(1);
        const images = getCaseStudyImages(rightItem);
        let bgImage = images && images.length ? images[0] : null;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_PageTpl, {
            className: caseStudy.url,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(PageBuilder, {
                    page: caseStudy === null || caseStudy === void 0 ? void 0 : caseStudy.pageBuilder,
                    renderModule: this.renderModule
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(NextStory, {
                    title: rightItem.title,
                    backgroundImage: bgImage,
                    onClick: this.onRight
                })
            ]
        });
    }
    constructor(...args){
        super(...args);
        (0,src_define_property/* default */.Z)(this, "onClose", ()=>{
            var ref;
            const { closeUrl , router , routerStore  } = this.props;
            var ref1;
            const prevPath = (ref1 = (ref = routerStore.state) === null || ref === void 0 ? void 0 : ref.prevPath) !== null && ref1 !== void 0 ? ref1 : closeUrl;
            router.push(prevPath, {
                transition: "down"
            });
        });
        (0,src_define_property/* default */.Z)(this, "getNextItem", (offset)=>{
            const { articles  } = this.props;
            let viewingItemIdx = this.getCurrentItemIndex() + offset;
            if (viewingItemIdx < 0) {
                viewingItemIdx = articles.length - 1;
            } else if (viewingItemIdx >= articles.length) {
                viewingItemIdx = 0;
            }
            const nextItem = articles[viewingItemIdx];
            return nextItem;
        });
        (0,src_define_property/* default */.Z)(this, "changeViewingItem", (offset)=>{
            const { router , routerStore , urlPrefix  } = this.props;
            const nextItem = this.getNextItem(offset);
            // forward on the prev state so close works after we navigate to different case studies
            router.push("".concat(urlPrefix).concat(nextItem.id), {
                ...routerStore.state,
                transition: offset === -1 ? "left" : "right"
            });
        });
        (0,src_define_property/* default */.Z)(this, "onLeft", ()=>{
            this.changeViewingItem(-1);
        });
        (0,src_define_property/* default */.Z)(this, "onRight", ()=>{
            this.changeViewingItem(1);
        });
        (0,src_define_property/* default */.Z)(this, "getCurrentItemIndex", ()=>{
            const { match2 , articles  } = this.props;
            const id = Number(match2[1]);
            const caseStudyIndex = articles.findIndex((item)=>item.id === id);
            return caseStudyIndex;
        });
        (0,src_define_property/* default */.Z)(this, "getCurrentItem", ()=>{
            const idx = this.getCurrentItemIndex();
            if (idx === -1) {
                return null;
            }
            return this.props.articles[idx];
        });
        (0,src_define_property/* default */.Z)(this, "renderModule", (param)=>{
            let { definition , pmodule , index  } = param;
            const extraProps = [
                {
                    name: "page_header_module",
                    onClose: this.onClose,
                    onLeft: this.onLeft,
                    onRight: this.onRight,
                    className: "with-navigation"
                }
            ];
            const props = extraProps.find((mp)=>mp.name === definition.name);
            const Component = definition.component;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, {
                ...definition,
                ...pmodule,
                ...props
            }, index);
        });
    }
}
const ArticlePageWithRouter = (0,store_router/* withRouter */.EN)(ArticlePage);
function CaseStudyArticle(props) {
    const caseStudiesStore = (0,caseStudies/* useCaseStudiesStore */.rY)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticlePageWithRouter, {
        ...props,
        articles: caseStudiesStore.caseStudies,
        urlPrefix: "/case-study/",
        closeUrl: "/"
    });
}
function NewsArticle(props) {
    const newsStore = (0,news/* useNewsStore */.m)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticlePageWithRouter, {
        ...props,
        articles: newsStore.news,
        urlPrefix: "/news/",
        closeUrl: "/news"
    });
}

;// CONCATENATED MODULE: ./src/pages/DevTestPage.js


const DevTestPage = (props)=>{
    // const {title, description, className, buttonText, clickable, image, underlayImage} = this.props;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            "helo",
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HoverCard, {
                title: "title",
                description: "desc",
                image: "https://jpwebsiteapi.kinsta.cloud/wp-content/uploads/2021/12/Nabula-Brdar-1-e1640057312530.jpeg"
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/path-to-regexp/dist.es2015/index.js
var dist_es2015 = __webpack_require__(1068);
;// CONCATENATED MODULE: ./src/utils/path-match.js

const matchPath = (pathname, params)=>{
    if (!params.path) {
        return null;
    }
    const regexp = (0,dist_es2015/* pathToRegexp */.Bo)(params.path, [], params);
    const r = regexp.exec(pathname);
    return r;
};

;// CONCATENATED MODULE: ./src/services/routes.js






var routes = [
    {
        title: "Home",
        pathname: "/",
        component: PageBuilderPage,
        transition: "up"
    },
    {
        title: "About",
        pathname: "/about",
        component: PageBuilderPage,
        transition: "up"
    },
    {
        title: "What",
        pathname: null,
        children: [
            {
                title: "Strategy",
                pathname: "/strategy",
                component: PageBuilderPage,
                transition: "up"
            },
            {
                title: "Digital",
                pathname: "/digital",
                component: PageBuilderPage,
                transition: "up"
            },
            {
                title: "Creative",
                pathname: "/creative",
                component: PageBuilderPage,
                transition: "up"
            },
            {
                title: "Communications<br/>and Social Media",
                pathname: "/social",
                component: PageBuilderPage,
                transition: "up"
            }
        ]
    },
    {
        title: "Work",
        pathname: "/work",
        component: PageBuilderPage,
        transition: "up"
    },
    {
        title: "Team",
        pathname: "/team",
        component: PageBuilderPage,
        transition: "down",
        children: [
            {
                title: "Our Team",
                pathname: "/team",
                component: PageBuilderPage,
                transition: "down"
            },
            {
                title: "Careers",
                pathname: "/careers",
                component: PageBuilderPage,
                transition: "up"
            }
        ]
    },
    {
        title: null,
        pathname: "/news/:id",
        component: NewsArticle,
        transition: "up"
    },
    {
        title: "News",
        pathname: "/news",
        component: NewsFeed,
        transition: "up"
    },
    {
        title: "Contact",
        pathname: "/contact",
        component: Contact,
        transition: "up"
    },
    {
        title: null,
        pathname: "/case-study/:id",
        component: CaseStudyArticle,
        transition: "up"
    },
    {
        title: null,
        pathname: "/privacy",
        component: PageBuilderPage,
        transition: "up"
    },
    {
        title: null,
        pathname: "/test",
        component: PageBuilderPage,
        transition: "up"
    },
    {
        title: null,
        pathname: "/devtest",
        component: DevTestPage,
        transition: "up"
    }
];
const cleanPathname = (pathname)=>{
    if (!pathname) {
        return null;
    }
    let cleanPath = pathname.replace("/index.html", "").replace("/index", "");
    if (cleanPath.length > 1 && cleanPath.endsWith("/")) {
        cleanPath = cleanPath.slice(0, -1);
    }
    return cleanPath;
};
const findRoute = function(pathname) {
    let p_routes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : routes;
    const cleanPath = cleanPathname(pathname);
    for (const r of p_routes){
        const match = matchPath(cleanPath, {
            path: r.pathname,
            exact: true,
            strict: false
        });
        if (match) {
            return r;
        }
        if (r.children) {
            const rc = findRoute(pathname, r.children);
            if (rc) {
                return rc;
            }
        }
    }
    return null;
};

;// CONCATENATED MODULE: ./src/Navigation.js











const duration = config/* default.DEBUG.SLOW_MOTION_PAGE_TRANSITION */.Z.DEBUG.SLOW_MOTION_PAGE_TRANSITION ? 40.0 : 0.6;
//
// Used this as a guide to get me started:
// https://css-tricks.com/animating-between-views-in-react/
//
// It has some stuff about animating at the right time so might need to look into this (ie. on page load or something)
//
const playEnter = (pathname, node, appears, transition)=>{
    let extras = {};
    switch(transition){
        case "up":
            extras = {
                x: 0,
                y: "100%"
            };
            break;
        case "down":
            extras = {
                x: 0,
                y: "-100%"
            };
            break;
        case "right":
            extras = {
                x: "100%",
                y: 0
            };
            break;
        case "left":
            extras = {
                x: "-100%",
                y: 0
            };
            break;
        default:
            console.error("Bad transition!");
            break;
    }
    const timeline = gsap/* gsap.timeline */.p8.timeline();
    timeline.set(node, {
        css: {
            zIndex: 100 /*, overflow: 'hidden'*/ 
        }
    });
    timeline.to(node, {
        ...extras,
        duration: 0
    });
    timeline.to(node, {
        x: 0,
        y: 0,
        duration
    });
    timeline.set(node, {
        clearProps: "all"
    }); //{css: {zIndex: 100, overflow: 'auto'}}); // leave at front and show overflow
    timeline.play();
};
const playExit = (pathname, node, appears, transition)=>{
    const movement = "20%";
    let extras = {};
    switch(transition){
        case "up":
            extras = {
                x: 0,
                y: "-".concat(movement)
            };
            break;
        case "down":
            extras = {
                x: 0,
                y: "".concat(movement)
            };
            break;
        case "right":
            extras = {
                x: "-".concat(movement),
                y: 0
            };
            break;
        case "left":
            extras = {
                x: "".concat(movement),
                y: 0
            };
            break;
        default:
            console.error("Bad transition!");
            break;
    }
    const timeline = gsap/* gsap.timeline */.p8.timeline();
    timeline.set(node, {
        css: {
            zIndex: -100
        }
    });
    timeline.to(node, {
        x: 0,
        y: 0,
        duration: 0
    });
    timeline.to(node, {
        ...extras,
        duration
    });
    timeline.play();
};
function Route(param) {
    let { currentRoute , pathname  } = param;
    var ref;
    const pagesStore = (0,pages/* usePagesStore */.TG)();
    const page = (ref = pagesStore.pages) === null || ref === void 0 ? void 0 : ref.find((p)=>{
        return (p === null || p === void 0 ? void 0 : p.url) === pathname;
    });
    // use the currentRoute component OR assemble a page using the page builder OR page not found
    const CurrentRouteComponent = (currentRoute === null || currentRoute === void 0 ? void 0 : currentRoute.component) || page && page.page_builder && PageBuilderPage || PageNotFound;
    const props = (currentRoute === null || currentRoute === void 0 ? void 0 : currentRoute.componentProps) || {};
    var ref1;
    const match = matchPath(pathname, {
        path: (ref1 = currentRoute === null || currentRoute === void 0 ? void 0 : currentRoute.pathname) !== null && ref1 !== void 0 ? ref1 : "",
        exact: true,
        strict: false
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrentRouteComponent, {
        match2: match,
        page: page,
        ...props
    });
}
function Nav() {
    var ref;
    const router = (0,store_router/* useRouter */.tv)();
    const pagesStore = (0,pages/* usePagesStore */.TG)();
    const currentPathname = cleanPathname(router.asPath);
    const currentRoute = findRoute(currentPathname);
    const currentPage = (ref = pagesStore.pages) === null || ref === void 0 ? void 0 : ref.find((p)=>{
        return (p === null || p === void 0 ? void 0 : p.url) === currentPathname;
    });
    const onExit = (node, appears)=>{
        var ref;
        const routerStore = store_router/* useRouterStore.getState */.Um.getState();
        const transition = ((ref = routerStore.state) === null || ref === void 0 ? void 0 : ref.transition) || (currentPage === null || currentPage === void 0 ? void 0 : currentPage.transition) || (currentRoute === null || currentRoute === void 0 ? void 0 : currentRoute.transition) || "up"; // override transition
        playExit(currentPathname, node, appears, transition);
    };
    const onEnter = (node, appears)=>{
        var ref;
        const routerStore = store_router/* useRouterStore.getState */.Um.getState();
        const transition = ((ref = routerStore.state) === null || ref === void 0 ? void 0 : ref.transition) || (currentPage === null || currentPage === void 0 ? void 0 : currentPage.transition) || (currentRoute === null || currentRoute === void 0 ? void 0 : currentRoute.transition) || "up"; // override transition
        playEnter(currentPathname, node, appears, transition);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TransitionGroup/* default */.Z, {
        component: null,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Transition/* default */.ZP, {
            onEnter: onEnter,
            onExit: onExit,
            timeout: duration * 1000,
            className: "transition ".concat(currentPathname),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Route, {
                currentRoute: currentRoute,
                pathname: currentPathname
            }, currentPathname)
        }, currentPathname)
    });
}

;// CONCATENATED MODULE: ./src/components/Menu.js










class Menu extends react.Component {
    render() {
        const { visible , menuBarsVisible  } = this.state;
        // we pass the current pathname into the navlink such that on the next page we can tell which page we came from
        // which we need to know in order to render the transition
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "menu",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
                    className: "btn-menu-container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "btn-menu",
                        onClick: ()=>this.setState({
                                visible: true
                            }),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_CSSTransition/* default */.Z, {
                                in: menuBarsVisible,
                                timeout: 500,
                                classNames: "fade",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(image_Image, {
                                    src: src_assets.menu_bars,
                                    alt: ""
                                })
                            }, "menu_bars"),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_CSSTransition/* default */.Z, {
                                in: !menuBarsVisible,
                                timeout: 500,
                                classNames: "fade",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(image_Image, {
                                    src: src_assets.menu_logo,
                                    alt: ""
                                })
                            }, "menu_logo")
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_CSSTransition/* default */.Z, {
                    in: visible,
                    timeout: 300,
                    classNames: "slide",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "dropdown",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                    children: routes.map(this.renderNav)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "btn-x-container",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: "btn-x",
                                        onClick: ()=>this.setState({
                                                visible: false
                                            }),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(image_Image, {
                                            src: src_assets.x,
                                            alt: "close button"
                                        })
                                    })
                                })
                            ]
                        })
                    })
                })
            ]
        });
    }
    constructor(props){
        super(props);
        (0,src_define_property/* default */.Z)(this, "state", {
            visible: false,
            activeLi: null,
            menuBarsVisible: false
        });
        (0,src_define_property/* default */.Z)(this, "toggleLiActive", (li)=>{
            if (!li) {
                return {};
            }
            // https://www.w3schools.com/howto/howto_js_collapsible.asp
            // https://www.w3schools.com/howto/tryit.asp?filename=tryhow_js_accordion_animate
            const buttonContainer = li.children.length >= 1 && li.children[0];
            const panel = li.children.length >= 2 && li.children[1];
            if (panel) {
                if (panel.style.maxHeight) {
                    buttonContainer.classList.remove("expanded");
                    panel.style.maxHeight = null;
                } else {
                    buttonContainer.classList.add("expanded");
                    panel.style.maxHeight = panel.scrollHeight + "px";
                }
            }
            return {
                li,
                panel
            };
        });
        (0,src_define_property/* default */.Z)(this, "onNavClick", (e, n)=>{
            const { router  } = this.props;
            const { pathname  } = n;
            if (pathname) {
                this.setState({
                    visible: false
                });
                router.push(pathname);
            }
        });
        (0,src_define_property/* default */.Z)(this, "onToggleExpand", (e, n)=>{
            const { children  } = n;
            const { target  } = e;
            let activeLi = this.state.activeLi;
            // collapse the old active menu item
            if (activeLi) {
                this.toggleLiActive(activeLi);
                if (target.parentElement.parentElement.parentElement === activeLi) {
                    activeLi = null;
                    this.setState({
                        activeLi: null
                    });
                    return;
                }
                activeLi = null;
            }
            // we are dealing with a accordian menu button
            if (children) {
                // active the new menu item
                const { panel , li  } = this.toggleLiActive(target.parentElement.parentElement.parentElement);
                if (panel) {
                    this.setState({
                        activeLi: li
                    });
                }
                return;
            }
            this.setState({
                visible: false,
                activeLi
            });
        });
        (0,src_define_property/* default */.Z)(this, "renderNav", (n, index)=>{
            const locationPath = this.props.router.asPath;
            //const {location} = this.props;
            let { pathname , title , component , children  } = n;
            if (!title) {
                return null;
            }
            if (!component) {
                pathname = ""; // stop the user going to bad paths!
            }
            const isLast = pathname === "/contact";
            const active = locationPath === pathname;
            //console.log("pathname:", pathname, "title:", title);
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                id: "".concat(pathname, "-").concat(index),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "button-container",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                onClick: (e)=>this.onNavClick(e, n),
                                className: "btn-link ".concat(children ? "parent" : "", " ").concat(active ? "active" : "", " ").concat(pathname ? "valid" : "invalid"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    dangerouslySetInnerHTML: {
                                        __html: title
                                    },
                                    className: "label"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                onClick: (e)=>this.onToggleExpand(e, n),
                                className: "btn-arrow ".concat(children ? "parent" : "", " ").concat(active ? "active" : ""),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(image_Image, {
                                    src: src_assets.menu_arrow_down,
                                    className: "arrow"
                                })
                            })
                        ]
                    }),
                    children && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        children: children.map(this.renderNav)
                    }),
                    isLast && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Social, {})
                ]
            }, "".concat(pathname, "-").concat(index));
        });
        this.timer = setInterval(()=>{
            this.setState({
                menuBarsVisible: !this.state.menuBarsVisible
            });
        }, 5000);
    }
}
/* harmony default export */ var components_Menu = ((0,store_router/* withRouter */.EN)(Menu));

// EXTERNAL MODULE: ./src/store/app.js
var app = __webpack_require__(6206);
;// CONCATENATED MODULE: ./src/pages/Landing.js








class LandingComp extends (/* unused pure expression or super */ null && (Component)) {
    componentDidMount() {
        if (!Config.DEBUG.SHOW_LANDING) {
            return;
        }
        document.body.style.overflow = "hidden";
        document.onkeypress = this.onInputEvent;
        document.onmousedown = this.onInputEvent;
    }
    render() {
        const { onClick , appLoading  } = this.props;
        const { keyPressed  } = this.state;
        if (!Config.DEBUG.SHOW_LANDING) {
            return null;
        }
        let showContinuePrompt = !appLoading;
        let visible = appLoading; //!keyPressed;
        return /*#__PURE__*/ _jsx(CSSTransition, {
            in: !visible,
            timeout: 300,
            classNames: "fade",
            onEnter: this.showScroll,
            children: /*#__PURE__*/ _jsx("div", {
                className: "landing-page",
                onClick: onClick,
                children: /*#__PURE__*/ _jsx("div", {
                    className: "logo",
                    children: /*#__PURE__*/ _jsx(Image, {
                        src: assets["landing_logo"]
                    })
                })
            })
        });
    }
    constructor(props){
        super(props);
        _define_property(this, "onInputEvent", (e)=>{
            if (this.props.appLoading) {
                return;
            }
            this.setState({
                keyPressed: true
            });
            document.onkeypress = null;
            document.onmousedown = null;
        });
        _define_property(this, "showScroll", ()=>{
            document.body.style.overflow = "auto";
        });
        this.state = {
            keyPressed: false
        };
    }
}
function Landing() {
    const appStore = useAppStore();
    return /*#__PURE__*/ _jsx(LandingComp, {
        appLoading: appStore.appLoading
    });
}

;// CONCATENATED MODULE: ./src/App.js






function App() {
    const isMobile = useIsMobile();
    const [landingVisible, setLandingVisible] = (0,react.useState)(true);
    (0,react.useEffect)(()=>{
        document.body.className = isMobile ? "mobile" : "";
    }, [
        isMobile
    ]);
    const hideLanding = ()=>{
        setLandingVisible(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Menu, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav, {})
        ]
    });
}

;// CONCATENATED MODULE: ./pages/[[...index]].js
var __N_SSG = true;



/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [802,553,774,888,179], function() { return __webpack_exec__(5194); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);